// extracted by css-extract-rspack-plugin
export default {"verificationEmployerIcon":"verification-employer-icon--U7C87PYaRQcp2d4r"};